var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_385_1860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_385_1860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 18C15.825 18 16.5313 17.7063 17.1188 17.1188C17.7063 16.5313 18 15.825 18 15C18 14.175 17.7063 13.4688 17.1188 12.8813C16.5313 12.2938 15.825 12 15 12C14.175 12 13.4688 12.2938 12.8813 12.8813C12.2938 13.4688 12 14.175 12 15C12 15.825 12.2938 16.5313 12.8813 17.1188C13.4688 17.7063 14.175 18 15 18ZM9 24H21V23.1375C21 22.5375 20.8375 21.9875 20.5125 21.4875C20.1875 20.9875 19.7375 20.6125 19.1625 20.3625C18.5125 20.0875 17.8438 19.875 17.1562 19.725C16.4687 19.575 15.75 19.5 15 19.5C14.25 19.5 13.5313 19.575 12.8438 19.725C12.1562 19.875 11.4875 20.0875 10.8375 20.3625C10.2625 20.6125 9.8125 20.9875 9.4875 21.4875C9.1625 21.9875 9 22.5375 9 23.1375V24ZM24.75 30H5.25C4.65 30 4.125 29.775 3.675 29.325C3.225 28.875 3 28.35 3 27.75V2.25C3 1.65 3.225 1.125 3.675 0.675C4.125 0.225 4.65 0 5.25 0H18.0375L27 8.9625V27.75C27 28.35 26.775 28.875 26.325 29.325C25.875 29.775 25.35 30 24.75 30ZM24.75 27.75V9.975L17.025 2.25H5.25V27.75H24.75Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.3ea38b72fd5a68283b50bf154dba08df.svg";
export { ForwardRef as ReactComponent };